if (!customElements.get("product-form")) {
  let getProductTitle = function(productForm) {
    const productInfo = productForm.closest("product-info") || document;
    const title = productInfo.querySelector(".product__title h1, .product__title h2");
    return title ? title.textContent.trim() : "";
  }, saveApplicationServiceChoice = function(choice, productTitle) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        attributes: {
          "Application Services": choice,
          "Application Services Product": productTitle || ""
        }
      })
    });
  }, saveApplicationServiceDetails = function(productTitle, details) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        attributes: {
          "Application Services": "Yes",
          "Application Services Product": productTitle || "",
          "Application Service Customer Name": details.name || "",
          "Application Service Mobile": details.mobile || "",
          "Application Service Location PIN": details.pin || ""
        }
      })
    });
  }, ensureApplicationServiceModal = function() {
    let modal = document.getElementById(SS_APPLICATION_SERVICE_MODAL_ID);
    if (modal) return modal;
    modal = document.createElement("div");
    modal.id = SS_APPLICATION_SERVICE_MODAL_ID;
    modal.className = "ss-app-service-modal";
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.setAttribute("aria-labelledby", "ss-app-service-modal-title");
    modal.hidden = true;
    modal.innerHTML = `
      <div class="ss-app-service-modal__backdrop" data-ss-app-service-close></div>
      <div class="ss-app-service-modal__panel" role="document" tabindex="-1">
        <button class="ss-app-service-modal__close" type="button" aria-label="Close" data-ss-app-service-close>&times;</button>
        <h2 class="ss-app-service-modal__title" id="ss-app-service-modal-title">Need Application Help?</h2>
        <p class="ss-app-service-modal__message">We can arrange professional application support for this product.</p>
        <div class="ss-app-service-modal__choice" data-ss-app-service-choice>
          <div class="ss-app-service-modal__actions">
            <button class="ss-app-service-modal__btn ss-app-service-modal__btn--primary" type="button" data-ss-app-service-yes>
              Yes, Contact Me
            </button>
            <button class="ss-app-service-modal__btn ss-app-service-modal__btn--secondary" type="button" data-ss-app-service-no>
              No, Continue
            </button>
          </div>
        </div>
        <form class="ss-app-service-modal__form" data-ss-app-service-form hidden>
          <label class="ss-app-service-modal__field">
            <span>Customer name</span>
            <input type="text" name="customer_name" autocomplete="name" required>
          </label>
          <label class="ss-app-service-modal__field">
            <span>Mobile number</span>
            <input type="tel" name="mobile_number" autocomplete="tel" inputmode="tel" required>
          </label>
          <label class="ss-app-service-modal__field">
            <span>Location PIN code</span>
            <input type="text" name="location_pin" autocomplete="postal-code" inputmode="numeric" required>
          </label>
          <p class="ss-app-service-modal__error" data-ss-app-service-error hidden>Please fill all details before continuing.</p>
          <button class="ss-app-service-modal__btn ss-app-service-modal__btn--primary" type="button" data-ss-app-service-yes>
            Continue
          </button>
          <button class="ss-app-service-modal__btn ss-app-service-modal__btn--secondary" type="button" data-ss-app-service-back>
            Back
          </button>
        </form>
      </div>
    `;
    if (!document.getElementById("ss-application-service-modal-style")) {
      const style = document.createElement("style");
      style.id = "ss-application-service-modal-style";
      style.textContent = `
        .ss-app-service-modal {
          position: fixed;
          inset: 0;
          z-index: 2147483647;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 18px;
          font-family: var(--ss-font-primary, Poppins, sans-serif);
        }

        html.ss-app-service-modal-open,
        body.ss-app-service-modal-open {
          overflow: hidden !important;
          overscroll-behavior: none;
          touch-action: none;
        }

        body.ss-app-service-modal-open > *:not(#ss-application-service-modal):not(script):not(style) {
          filter: blur(4px);
          transition: filter 0.18s ease;
          pointer-events: none;
        }

        .ss-app-service-modal[hidden] {
          display: none;
        }

        .ss-app-service-modal__backdrop {
          position: absolute;
          inset: 0;
          background: rgba(10, 15, 28, 0.82);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
        }

        .ss-app-service-modal__panel {
          position: relative;
          width: min(100%, 460px);
          padding: 28px 24px 24px;
          border: 1px solid rgba(255, 255, 255, 0.98);
          border-radius: 18px;
          background: #fff;
          color: #14192b;
          box-shadow: 0 32px 90px rgba(0, 0, 0, 0.48), 0 0 0 1px rgba(196, 0, 0, 0.06);
          outline: none;
        }

        .ss-app-service-modal__close {
          position: absolute;
          top: 12px;
          right: 12px;
          width: 34px;
          height: 34px;
          border: 1px solid rgba(196, 0, 0, 0.16);
          border-radius: 999px;
          background: #fef2f2;
          color: #c40000;
          font-size: 22px;
          line-height: 1;
          cursor: pointer;
        }

        .ss-app-service-modal__title {
          margin: 0 42px 12px 0;
          color: #14192b;
          font-size: 22px;
          font-weight: 800;
          line-height: 1.2;
          letter-spacing: 0;
        }

        .ss-app-service-modal__message,
        .ss-app-service-modal__copy {
          margin: 0 0 12px;
          color: #5c6170;
          font-size: 14px;
          line-height: 1.6;
        }

        .ss-app-service-modal__actions {
          display: grid;
          gap: 10px;
          margin-top: 20px;
        }

        .ss-app-service-modal__form {
          display: grid;
          gap: 12px;
          margin-top: 18px;
        }

        .ss-app-service-modal__form[hidden] {
          display: none;
        }

        .ss-app-service-modal__field {
          display: grid;
          gap: 6px;
          color: #14192b;
          font-size: 13px;
          font-weight: 700;
        }

        .ss-app-service-modal__field input {
          width: 100%;
          min-height: 46px;
          padding: 0 14px;
          border: 1px solid #d9e1ec;
          border-radius: 12px;
          background: #fff;
          color: #14192b;
          font: inherit;
          font-weight: 600;
          outline: none;
        }

        .ss-app-service-modal__field input:focus {
          border-color: #c40000;
          box-shadow: 0 0 0 3px rgba(196, 0, 0, 0.12);
        }

        .ss-app-service-modal__error {
          margin: 0;
          color: #b91c1c;
          font-size: 12px;
          font-weight: 700;
        }

        .ss-app-service-modal__btn {
          min-height: 48px;
          padding: 0 18px;
          border-radius: 999px;
          font-family: var(--ss-font-primary, Poppins, sans-serif);
          font-size: 14px;
          font-weight: 800;
          cursor: pointer;
        }

        .ss-app-service-modal__btn--primary {
          border: 0;
          background: #c40000;
          color: #fff;
          box-shadow: 0 12px 24px rgba(196, 0, 0, 0.24);
        }

        .ss-app-service-modal__btn--secondary {
          border: 1px solid #e2e8f0;
          background: #f8fafc;
          color: #14192b;
        }

        @media screen and (max-width: 480px) {
          .ss-app-service-modal {
            align-items: flex-end;
            padding: 0;
          }

          .ss-app-service-modal__panel {
            width: 100%;
            border-radius: 20px 20px 0 0;
            padding: 26px 18px max(24px, env(safe-area-inset-bottom));
          }
        }
      `;
      document.head.appendChild(style);
    }
    document.body.appendChild(modal);
    return modal;
  }, openApplicationServiceModal = function(productTitle) {
    const modal = ensureApplicationServiceModal();
    const panel = modal.querySelector(".ss-app-service-modal__panel");
    const choiceView = modal.querySelector("[data-ss-app-service-choice]");
    const detailsForm = modal.querySelector("[data-ss-app-service-form]");
    const yesButton = choiceView.querySelector("[data-ss-app-service-yes]");
    const submitDetailsButton = detailsForm.querySelector("[data-ss-app-service-yes]");
    const noButton = modal.querySelector("[data-ss-app-service-no]");
    const backButton = modal.querySelector("[data-ss-app-service-back]");
    const errorMessage = modal.querySelector("[data-ss-app-service-error]");
    const closeButtons = modal.querySelectorAll("[data-ss-app-service-close]");
    const closeModal = () => {
      modal.hidden = true;
      document.documentElement.classList.remove("ss-app-service-modal-open");
      document.body.classList.remove("ss-app-service-modal-open");
    };
    const goToCart = () => {
      document.documentElement.classList.remove("ss-app-service-modal-open");
      document.body.classList.remove("ss-app-service-modal-open");
      window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : "/cart";
    };
    const choose = (choice) => {
      saveApplicationServiceChoice(choice, productTitle).catch(() => {
      }).finally(goToCart);
    };
    choiceView.hidden = false;
    detailsForm.hidden = true;
    detailsForm.reset();
    errorMessage.hidden = true;
    submitDetailsButton.removeAttribute("aria-disabled");
    yesButton.onclick = () => {
      choiceView.hidden = true;
      detailsForm.hidden = false;
      detailsForm.querySelector("input").focus();
    };
    submitDetailsButton.onclick = () => {
      if (submitDetailsButton.getAttribute("aria-disabled") === "true") return;
      if (!detailsForm.checkValidity()) {
        errorMessage.hidden = false;
        detailsForm.reportValidity();
        return;
      }
      errorMessage.hidden = true;
      submitDetailsButton.setAttribute("aria-disabled", "true");
      saveApplicationServiceDetails(productTitle, {
        name: detailsForm.elements.customer_name.value.trim(),
        mobile: detailsForm.elements.mobile_number.value.trim(),
        pin: detailsForm.elements.location_pin.value.trim()
      }).catch(() => {
      }).finally(goToCart);
    };
    noButton.onclick = () => choose("No");
    backButton.onclick = () => {
      detailsForm.hidden = true;
      choiceView.hidden = false;
      yesButton.focus();
    };
    closeButtons.forEach((button) => {
      button.onclick = () => {
        closeModal();
      };
    });
    modal.hidden = false;
    document.documentElement.classList.add("ss-app-service-modal-open");
    document.body.classList.add("ss-app-service-modal-open");
    panel.focus();
  }, hasShownApplicationServiceModal = function() {
    try {
      return sessionStorage.getItem(SS_APPLICATION_SERVICE_SESSION_KEY) === "true";
    } catch (error) {
      return window.__ssApplicationServicePromptShown === true;
    }
  }, markApplicationServiceModalShown = function() {
    try {
      sessionStorage.setItem(SS_APPLICATION_SERVICE_SESSION_KEY, "true");
    } catch (error) {
      window.__ssApplicationServicePromptShown = true;
    }
  }, openApplicationServiceModalOnce = function(productTitle) {
    if (hasShownApplicationServiceModal()) return;
    markApplicationServiceModalShown();
    openApplicationServiceModal(productTitle);
  }, updateStarShieldCartCounters = function(itemCount) {
    const headerCartLink = document.getElementById("ss-header-cart-icon");
    const headerBadge = document.querySelector(".ss-header__cart-badge");
    const cartHeaderCount = document.querySelector(".ss-cart-header__count");
    const displayCount = Math.min(itemCount, 99);
    if (headerCartLink) {
      headerCartLink.setAttribute("aria-label", itemCount > 0 ? `Cart (${itemCount} items)` : "Cart");
    }
    if (headerBadge && itemCount === 0) {
      headerBadge.remove();
    } else if (headerBadge) {
      headerBadge.textContent = displayCount;
      headerBadge.hidden = false;
    } else if (headerCartLink && itemCount > 0) {
      const badge = document.createElement("span");
      badge.className = "ss-header__cart-badge";
      badge.setAttribute("aria-hidden", "true");
      badge.textContent = displayCount;
      headerCartLink.appendChild(badge);
    }
    if (cartHeaderCount) {
      cartHeaderCount.textContent = itemCount;
      cartHeaderCount.setAttribute("aria-label", `${itemCount} items in cart`);
    }
  }, refreshStarShieldCartCounters = function() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then((response) => response.json()).then((cart) => {
      updateStarShieldCartCounters(cart.item_count || 0);
      return cart;
    });
  }, initApplicationServiceCartAddLinks = function() {
    if (document.documentElement.dataset.ssAppServiceLinkHandler === "true") return;
    document.documentElement.dataset.ssAppServiceLinkHandler = "true";
    document.addEventListener("click", (event) => {
      const link = event.target.closest("[data-ss-application-service-add]");
      if (!link) return;
      event.preventDefault();
      event.stopPropagation();
      if (link.getAttribute("aria-disabled") === "true") return;
      const url = new URL(link.href, window.location.origin);
      const body = new URLSearchParams();
      body.set("id", url.searchParams.get("id") || link.dataset.variantId || "");
      body.set("quantity", url.searchParams.get("quantity") || link.dataset.quantity || "1");
      link.setAttribute("aria-disabled", "true");
      fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : "/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json"
        },
        body: body.toString()
      }).then((response) => {
        if (!response.ok) throw new Error("Unable to add item to cart");
        return response.json();
      }).then(() => refreshStarShieldCartCounters()).then(() => {
        openApplicationServiceModalOnce(link.dataset.productTitle || "");
      }).catch(() => {
        window.location.href = link.href;
      }).finally(() => {
        link.removeAttribute("aria-disabled");
      });
    });
  };
  var getProductTitle2 = getProductTitle, saveApplicationServiceChoice2 = saveApplicationServiceChoice, saveApplicationServiceDetails2 = saveApplicationServiceDetails, ensureApplicationServiceModal2 = ensureApplicationServiceModal, openApplicationServiceModal2 = openApplicationServiceModal, hasShownApplicationServiceModal2 = hasShownApplicationServiceModal, markApplicationServiceModalShown2 = markApplicationServiceModalShown, openApplicationServiceModalOnce2 = openApplicationServiceModalOnce, updateStarShieldCartCounters2 = updateStarShieldCartCounters, refreshStarShieldCartCounters2 = refreshStarShieldCartCounters, initApplicationServiceCartAddLinks2 = initApplicationServiceCartAddLinks;
  const SS_APPLICATION_SERVICE_MODAL_ID = "ss-application-service-modal";
  const SS_APPLICATION_SERVICE_SESSION_KEY = "ssApplicationServicePromptShown";
  initApplicationServiceCartAddLinks();
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hideErrors = this.dataset.hideErrors === "true";
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config).then((response) => response.json()).then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: response.errors || response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.querySelector("span").classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: formData.get("id"),
              cartData: response
            });
          this.error = false;
          const productTitle = getProductTitle(this);
          const showApplicationServiceModal = () => {
            setTimeout(() => openApplicationServiceModalOnce(productTitle), 80);
          };
          const quickAddModal = this.closest("quick-add-modal");
          if (quickAddModal) {
            document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  try {
                    this.cart.renderContents(response);
                  } finally {
                    showApplicationServiceModal();
                  }
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            try {
              this.cart.renderContents(response);
            } finally {
              showApplicationServiceModal();
            }
          }
        }).catch((e) => {
          console.error(e);
        }).finally(() => {
          this.submitButton.classList.remove("loading");
          if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading__spinner").classList.add("hidden");
        });
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
